<template>
  <v-application v-if="access.setting_taxes">
    <v-settings>
      <v-crud-card
        name="tax"
        v-bind:headers="headers"
        v-bind:data="taxes"
        v-bind:remove="tax_remove"
        v-bind:save="tax_save"
        v-bind:row="typing_tax"
        SettingsTaxe
        v-bind:add_button_name="'add_tax'"
        v-bind:saveDisabled="!is_valid"
      >
        <v-form v-model="is_valid">
          <v-card-text>
            <v-layout class="px-2" row>
              <v-flex md8 class="px-5">
                <v-text-field
                  v-model="tax.name"
                  :label="$t('name')"
                  :rules="[fieldRules.required]"
                />
              </v-flex>
              <v-flex md4 class="px-5">
                <v-text-field
                  v-model="tax.tax"
                  :label="$t('tax_rate')"
                  type="number"
                  :rules="[fieldRules.require]"
                />
              </v-flex>
              <v-flex md12 class="px-5">
                <v-select
                  :label="$t('type')"
                  v-model="tax.type"
                  v-bind:items="taxes_types"
                  :rules="[fieldRules.require]"
                />
              </v-flex>
              <v-flex md12 class="px-5">
                <v-select
                  :label="$t('options')"
                  v-model="tax.variant"
                  v-bind:items="taxes_options"
                />
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-form>
        <v-card-text>
          <v-list class="px-2">
            <v-list-item
              v-for="(service, index) in tax.services"
              v-bind:key="index"
            >
              <v-list-item-content>
                <v-list-item-title>{{
                  service.service_name
                }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-switch v-model="service.available" />
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-crud-card>
    </v-settings>
  </v-application>
  <error404 v-else></error404>
</template>
<script>
import Taxes from "../../mixins/taxes";
export default {
  name: "Taxes",
  mixins: [Taxes],
  data: () => ({
    headers: [
      { text: "Name", value: "name", sortable: false },
      { text: "Tax", value: "tax", sortable: false, align: "right" },
    ],
    is_valid: false,
  }),
  mounted() {
    this.headers = [
      {
        text: this.$t("name"),
        value: "name",
        sortable: false,
        available: true,
      },
      {
        text: this.$t("value"),
        value: "tax",
        sortable: false,
        align: "right",
        available: true,
      },
    ];
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>
